import reducer from "./reducers";
export { default as mmbActions } from "./actions";

export default reducer;